import type { BestSoftwareText } from './best-software.content';

export const BEST_SOFTWARE_AR: BestSoftwareText = {
  heroTitle: 'أفضل برنامج إدارة فنادق (٢٠٢٦)',
  heroSubtitle: 'اختبرنا وقارنّا أبرز منصات إدارة الفنادق حول العالم. إليك تصنيفاتنا بناءً على اكتمال المزايا، القيمة السعرية، سهولة الاستخدام، الانتشار العالمي، وجودة الدعم.',
  rankings: [
    {
      bestFor: 'الأفضل عمومًا — إدارة فندقية شاملة',
      highlights: ['٣٢ وحدة متكاملة', 'أسعار إقليمية بـ٦ عملات', 'محرك حجز بوك ماي روم مجاني'],
    },
    {
      bestFor: 'الأفضل للتوزيع العالمي',
      highlights: ['شبكة OTA عالمية قوية', 'منصة سحابية حديثة', 'إدارة قنوات جيدة'],
    },
    {
      bestFor: 'الأفضل للفنادق الاقتصادية',
      highlights: ['علامة تجارية راسخة منذ ٢٠١٠', 'واجهة نظام إدارة بسيطة', 'إدارة قنوات أساسية'],
    },
    {
      bestFor: 'الأفضل لفنادق المؤسسات',
      highlights: ['هندسة معمارية حديثة', 'حضور أوروبي قوي', 'سوق واجهات برمجية'],
    },
    {
      bestFor: 'الأفضل للعقارات المستقلة',
      highlights: ['مناسب للعقارات الفردية', 'أدوات تقارير لائقة', 'ربط OTA معتدل'],
    },
  ],
  evaluationCriteria: [
    {
      name: 'اكتمال المزايا',
      description: 'إجمالي عدد الوحدات، عمق الوظائف، وما إذا كانت الميزات الأساسية مثل نظام الإدارة ومدير القنوات ومحرك الحجز وأدوات الإيرادات مدمجة أم تتطلب إضافات.',
    },
    {
      name: 'الانتشار العالمي والامتثال',
      description: 'دعم العملات المتعددة، الامتثال الضريبي الإقليمي، تغطية منصات الحجز الدولية، اتصال نظام التوزيع العالمي، وخيارات بوابات الدفع للعقارات حول العالم.',
    },
    {
      name: 'القيمة السعرية',
      description: 'التكلفة مقارنة بالمزايا المتضمنة. نعاقب المنصات التي تفرض رسومًا إضافية على الوحدات الأساسية أو تتطلب إضافات مدفوعة للوظائف الضرورية.',
    },
    {
      name: 'سهولة الاستخدام',
      description: 'جودة تصميم واجهة المستخدم، تجربة الإعداد، منحنى التعلم، وإمكانية الوصول عبر الجوال. الواجهات الحديثة تحصل على درجات أعلى.',
    },
    {
      name: 'جودة الدعم',
      description: 'توفر الدعم (٢٤/٧ مقابل ساعات العمل)، أوقات الاستجابة، مساعدة الإعداد، وما إذا كان ترحيل البيانات مجانيًا أو مدفوعًا.',
    },
  ],
  faqItems: [
    {
      question: 'ما هو أفضل برنامج لإدارة الفنادق؟',
      answer: 'بناءً على تقييمنا لعام ٢٠٢٦، يحتل هوتيل ستاك المرتبة الأولى عمومًا. يوفر ٣٢ وحدة متكاملة، أسعار إقليمية متعددة العملات تبدأ من ٤٩$/شهريًا، تكاملات منصات حجز عالمية، ومحرك حجز مجاني — مما يجعله الخيار الأكثر اكتمالًا واقتصاديةً للفنادق حول العالم.',
    },
    {
      question: 'كم تكلفة برنامج إدارة الفنادق؟',
      answer: 'تتراوح تكلفة برامج إدارة الفنادق عادة من ٤٩$ إلى +٣٠٠$ شهريًا حسب المزايا وحجم العقار. يقدم هوتيل ستاك أفضل قيمة بسعر ٤٩$/شهريًا مع جميع الوحدات الـ٣٢. المنصات المؤسسية مثل ميوز تبدأ من +٢٠٠$/شهريًا.',
    },
    {
      question: 'ما المزايا التي يجب البحث عنها في برنامج فندقي؟',
      answer: 'المزايا الأساسية تشمل: نظام إدارة مع إدارة الغرف، مدير قنوات لمزامنة منصات الحجز، محرك حجز للحجوزات المباشرة، أدوات إدارة الإيرادات، إدارة علاقات الضيوف، إدارة التدبير المنزلي، فوترة متعددة العملات، وتقارير/تحليلات. يتضمن هوتيل ستاك كل هذا بالإضافة إلى ٢٤ وحدة إضافية.',
    },
    {
      question: 'هل البرامج الفندقية السحابية أفضل من المحلية؟',
      answer: 'نعم، يُنصح بالبرامج السحابية لمعظم الفنادق. توفر الوصول من أي جهاز، تحديثات تلقائية، عدم الحاجة لصيانة الخوادم، أمان أفضل، وتكاليف أولية أقل. جميع المنصات الأعلى تصنيفًا في قائمتنا (HotelStack.io وCloudbeds وMews) سحابية.',
    },
    {
      question: 'هل يمكنني تغيير البرنامج الفندقي دون فقدان البيانات؟',
      answer: 'نعم. تقدم معظم المنصات الحديثة خدمات ترحيل البيانات. يوفر هوتيل ستاك ترحيلًا مجانيًا من أي نظام حالي، بما في ذلك ملفات الضيوف وسجل الحجوزات وخطط الأسعار وتهيئات الغرف. يكتمل الترحيل عادة خلال ٤٨ ساعة بدون توقف.',
    },
  ],
};
